import { Badge } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { DirLeadStatusType } from '@econtractor/types';
import { tDirName } from 'utils/helpers/i18n/tDirName';

interface LeadDashboardCardProps {
    status: DirLeadStatusType;
    count: number | null;
}

const LeadDashboardCard = ({ status, count }: LeadDashboardCardProps) => {
    const { t } = useTranslation(['Leads']);
    const statusStyle = status.statusJson?.statusStyle || 'danger';
    const label = tDirName(t, status.i18nKey, status.statusName) || t(`status.${status.ID}`);

    return (
        <div className={`leads-dashboard__card is-${statusStyle}`}>
            <div className="leads-dashboard__count">
                {count === null ? '–' : count}
            </div>
            <Badge className="fs-12 text-truncate leads-dashboard__badge" bg={statusStyle} title={label}>
                {label}
            </Badge>
        </div>
    );
};

export default LeadDashboardCard;
